import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datePipeFr'
})



export class DatePipeFr  implements PipeTransform {
  transform(start_date:any): any {
    let days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
    let months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet','Aout','Septembre','Octobre','Novembre','Decembre'];
    let d = new Date(start_date.replace(/ /g,"T"));
    let dayname = days[d.getUTCDay()];
    let day= d.getUTCDate();
    let hours = d.getHours();

    let month = months[d.getMonth()];

    return day+' '+month+' '+d.getUTCFullYear();
  }
}
